// extracted by mini-css-extract-plugin
module.exports = {"code-highlight":"highlight_code-highlight___caZ6","bash":"highlight_bash__23PI6","json":"highlight_json__n86A_","curl":"highlight_curl__KJRqs"};